// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2Mycd","rootSuccess":"CompleteLink_rootSuccess__3so5O","rootFailure":"CompleteLink_rootFailure__N4XgQ","isDisabled":"CompleteLink_isDisabled__2R1vv"};